import { useEffect } from 'react';

import { useAppDispatch } from '@/hooks/store';
import { setUnreadChatV2 } from '@/store/slices/commsSlice';

import { useCommsUnread } from './api/useCommsUnread';
import { SupabaseProvider } from './supabase/SupabaseProvider';

interface CommsUnreadWatcherProps {
  isAuthenticated: boolean;
  userId?: string | number | null;
}

function UnreadReporter() {
  const dispatch = useAppDispatch();
  const { hasUnread } = useCommsUnread();
  useEffect(() => {
    dispatch(setUnreadChatV2(hasUnread));
  }, [dispatch, hasUnread]);
  useEffect(
    () => () => {
      dispatch(setUnreadChatV2(false));
    },
    [dispatch],
  );
  return null;
}

export default function CommsUnreadWatcher({
  isAuthenticated,
  userId,
}: CommsUnreadWatcherProps) {
  return (
    <SupabaseProvider
      forceEnabled
      isAuthenticated={isAuthenticated}
      userId={userId}
    >
      <UnreadReporter />
    </SupabaseProvider>
  );
}
